import { Injectable, Signal, computed, signal } from '@angular/core';

/** Tracks whether the app has volatile, reload-unsafe work in progress. Contributors register a
 *  boolean signal (a form's unsaved edits, a non-empty outbox); `busy` is true while any source
 *  is true. PwaUpdateService uses `!busy()` as its definition of "safe to auto-reload". */
@Injectable({ providedIn: 'root' })
export class AppActivityService {
  private readonly sources = signal<Signal<boolean>[]>([]);

  /** True while any registered source reports work in progress. */
  readonly busy: Signal<boolean> = computed(() => this.sources().some(s => s()));

  /** Register a busy source. Returns a deregister fn — call it on component destroy. */
  registerBusyProbe(src: Signal<boolean>): () => void {
    this.sources.update(list => [...list, src]);
    return () => this.sources.update(list => list.filter(s => s !== src));
  }
}
